module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-110.cbeb9445.svg";